import { render } from "./KioskHeader.vue?vue&type=template&id=f0c5690c"
import script from "./KioskHeader.vue?vue&type=script&lang=js"
export * from "./KioskHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__